//////////notification bar///////////////////////////

$(document).ready(function(){
    $(".close-bar").click(function(){
        $(".notification-bar").addClass("hide");
    });
});

///////////////featured-slider.liquid///////////////////

$(document).ready(function () {
  function initSlider() {
    var slidesToShow = 4;

    if ($(window).width() < 600) {
      slidesToShow = 1;
    } else if ($(window).width() < 989) {
      slidesToShow = 2;
    }else if ($(window).width() < 1195) {
      slidesToShow = 3;
    }
      $(".f-slidesnew").slick({
        infinite: true,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        dots: true,
        prevArrow:
          '<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none"><circle cx="40" cy="40.8064" r="40" fill="black"/><path d="M44.6869 32.3753C44.9355 32.624 45.0752 32.9612 45.0752 33.3129C45.0752 33.6645 44.9355 34.0017 44.6869 34.2504L38.1228 40.8145L44.6869 47.3787C44.9285 47.6288 45.0621 47.9638 45.0591 48.3114C45.0561 48.6591 44.9166 48.9917 44.6707 49.2376C44.4249 49.4835 44.0923 49.6229 43.7446 49.626C43.3969 49.629 43.0619 49.4953 42.8118 49.2538L35.3101 41.7521C35.0615 41.5034 34.9219 41.1662 34.9219 40.8145C34.9219 40.4629 35.0615 40.1257 35.3101 39.877L42.8118 32.3753C43.0605 32.1267 43.3977 31.9871 43.7494 31.9871C44.101 31.9871 44.4382 32.1267 44.6869 32.3753Z" fill="white"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none"><circle cx="40" cy="40.8064" r="40" fill="black"/><path d="M35.3131 49.2375C35.0645 48.9888 34.9248 48.6516 34.9248 48.2999C34.9248 47.9483 35.0645 47.6111 35.3131 47.3624L41.8772 40.7983L35.3131 34.2341C35.0715 33.984 34.9379 33.649 34.9409 33.3013C34.9439 32.9536 35.0834 32.621 35.3293 32.3752C35.5751 32.1293 35.9077 31.9899 36.2554 31.9868C36.6031 31.9838 36.9381 32.1175 37.1882 32.359L44.6899 39.8607C44.9385 40.1094 45.0781 40.4466 45.0781 40.7983C45.0781 41.1499 44.9385 41.4871 44.6899 41.7358L37.1882 49.2375C36.9395 49.4861 36.6023 49.6257 36.2506 49.6257C35.899 49.6257 35.5618 49.4861 35.3131 49.2375Z" fill="white"/></svg></button>',

      });
    
  }

  initSlider();


});

///////////////////////exciting-flavours2.liquid//////////////////

$(document).ready(function() {
    $(".pbutton").click(function() {
        var imgUrl = $(this).attr('data-img');
        $('.table_data img').attr('src', imgUrl);
        $('.popup').fadeIn(500);
    });
  $(document).on('click', '.popup .close1', function() {
      $('.table_data img').attr('src', '');
      $('.popup').fadeOut(500);
  });

});


/////////////featured-collection2.liquid////////////////////////////

$(document).ready(function () {
  function initSlider() {
    var slidesToShow = 4;

    if ($(window).width() < 769) {
      slidesToShow = 2;
    }
      if ($(window).width() < 481) {
      slidesToShow = 1;
    }
      $(".feat-slider").slick({
        infinite: true,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        dots: true,
        prevArrow:
          '<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none"><circle cx="40" cy="40.8064" r="40" fill="black"/><path d="M44.6869 32.3753C44.9355 32.624 45.0752 32.9612 45.0752 33.3129C45.0752 33.6645 44.9355 34.0017 44.6869 34.2504L38.1228 40.8145L44.6869 47.3787C44.9285 47.6288 45.0621 47.9638 45.0591 48.3114C45.0561 48.6591 44.9166 48.9917 44.6707 49.2376C44.4249 49.4835 44.0923 49.6229 43.7446 49.626C43.3969 49.629 43.0619 49.4953 42.8118 49.2538L35.3101 41.7521C35.0615 41.5034 34.9219 41.1662 34.9219 40.8145C34.9219 40.4629 35.0615 40.1257 35.3101 39.877L42.8118 32.3753C43.0605 32.1267 43.3977 31.9871 43.7494 31.9871C44.101 31.9871 44.4382 32.1267 44.6869 32.3753Z" fill="white"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none"><circle cx="40" cy="40.8064" r="40" fill="black"/><path d="M35.3131 49.2375C35.0645 48.9888 34.9248 48.6516 34.9248 48.2999C34.9248 47.9483 35.0645 47.6111 35.3131 47.3624L41.8772 40.7983L35.3131 34.2341C35.0715 33.984 34.9379 33.649 34.9409 33.3013C34.9439 32.9536 35.0834 32.621 35.3293 32.3752C35.5751 32.1293 35.9077 31.9899 36.2554 31.9868C36.6031 31.9838 36.9381 32.1175 37.1882 32.359L44.6899 39.8607C44.9385 40.1094 45.0781 40.4466 45.0781 40.7983C45.0781 41.1499 44.9385 41.4871 44.6899 41.7358L37.1882 49.2375C36.9395 49.4861 36.6023 49.6257 36.2506 49.6257C35.899 49.6257 35.5618 49.4861 35.3131 49.2375Z" fill="white"/></svg></button>',
      });
    
  }

  initSlider();


});


 $(document).ready(function () {
$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.slider-nav'
});


var $status = $('.pagingInfo');
var $slickElement = $('.slider-nav');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text(i + '/' + slick.slideCount);
});

$slickElement.slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="21" viewBox="0 0 13 21" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20.3237L-4.37114e-07 10.3237L10 0.32373L12.5 2.82373L5 10.3237L12.5 17.8237L10 20.3237Z" fill="black"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="21" viewBox="0 0 13 21" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0.32373L13 10.3237L3 20.3237L0.499999 17.8237L8 10.3237L0.5 2.82373L3 0.32373Z" fill="black"/></svg></button>',
  asNavFor: '.slider-for',
  dots: false,
  centerMode: true,
  focusOnSelect: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
});

